<template>
  <nav class="l-navigation"
     :class="{
      'is-open': isOpen
    }"
   :style="{
      height: `${height}px`
    }">
    <div class="l-navigation__content" :style="{
      height: `${height}px`
    }">
      <h2 class="l-navigation__heading">
        <router-link to="/" exact class="l-navigation__logo">SETOUCHI COMINCA STAYS</router-link>
      </h2>
      <ul class="l-navigation__list">
        <li class="u-fade">
          <router-link :to="{name: 'about'}">About Setouchi Cominca Stays</router-link>
        </li>
        <li class="u-fade">
          <a href="#" class="l-navigation__toggle" :class="{
            'is-open': isAccordionOpen
          }" @click.prevent="onClickToggle">Destination <span></span></a>
          <div class="l-navigation__accordion" :style="{
            'height': accordionHeight
          }">
            <ul class="l-navigation__destination" ref="destination" :style="{
              'height': `${listHeight}px`
            }">
              <li v-for="destination in destinations">
                <router-link :to="`/destination/${destination.post_name}`">{{ destination.acf.dest_name }}</router-link>
              </li>
              <!-- <li v-for="n in 20">
                <router-link :to="`/destination/`">Dummy</router-link>
              </li> -->
            </ul>
          </div>
        </li>
      </ul>
      <ul class="l-navigation__links u-fade" ref="links">
        <li><router-link :to="{name: 'privacypolicy'}">Privacy Policy</router-link></li>
        <li><router-link :to="{name: 'terms'}">Terms of Use</router-link></li>
        <li><a href="https://forms.gle/U95mXdSstduTMkbRA" target="_blank">Contact Us</a></li>
        <!-- <ul class="l-navigation__sns">
          <li><a href="#" target="_blank" class="l-navigation__icon" data-type="facebook">Facebook</a></li>
          <li><a href="#" target="_blank" class="l-navigation__icon" data-type="youtube">YouTube</a></li>
          <li><a href="#" target="_blank" class="l-navigation__icon" data-type="instagram">Instagram</a></li>
        </ul> -->
      </ul>
    </div>
  </nav>
</template>

<script>
  /**
   * Modules
   */
  import { mapGetters } from 'vuex'

  /**
   * Share Partial
   */

  export default {
    name: 'global-navigation',
    data() {
      return {
        destinations: [],
        isAccordionOpen: false,
        height: 0,
        listHeight: 0,
      }
    },
    computed: {
      accordionHeight() {
        return this.isAccordionOpen ? `calc(${this.listHeight}px + 1em)` : 0
      },
      ...mapGetters({
        'isOpen': 'menu/isOpen',
        'getInfo': 'route/getInfo',
      })
    },
    watch: {
      '$window.height'() {
        this.setHeight()
      },
      isOpen(value) {
        if(value) {
          this.height = global.innerHeight
        }
      }
    },
    mounted() {
      this.destinations = this.getInfo().destination_list;

      this.$nextTick(() => {
        this.setHeight()
      })
    },
    methods: {
      setHeight() {
        this.height = global.innerHeight

        this.listHeight = Math.abs(this.$refs.destination.getBoundingClientRect().top - this.$refs.links.getBoundingClientRect().top) - 20
      },
      onClickToggle() {
        this.isAccordionOpen = !this.isAccordionOpen
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/global-navigation.vue